import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs'

import { environment } from './../../../environments/environment'
import { Product, ProductOrderHistory } from '../../core/models/product'
import { AppliedFacets } from '../../facets/models/applied-facets'
import { parseFacets } from '../../facets/helpers/facet-parser'
import { RequestWrap } from '../../core/models/request-wrap';
import { handleEmpty } from '../../core/helpers/rx-pipes';
import { ThemeConfig } from '../../core/helpers/theme-config';
import { FavoriteProduct } from '../models/favorite-product';
import { FilterItem } from '../../shared/models/filter';

const productsUrl = '/products'
const favoritesUrl = '/favorites'
const productHistoryUrl = '/salesorders/lines'

@Injectable()
export class ProductService {
  constructor(private http: HttpClient) { }

  public findProducts(
    customerId: string,
    pageId?: string,
    facets?: AppliedFacets,
    onlyInStock?: boolean,
    pageNumber?: string,
    additionalParams?: string,
    searchTerm?: string,
    type?: string,
    noLimit?: boolean,
    filterItems?: FilterItem[],
    sortOrder?: string
    ): Observable<RequestWrap<Product[]>>
  {
    let url = `${environment.baseApiUrl}${productsUrl}`
    let params = parseFacets(facets)

    params = params.set('customerId', customerId).set('inStockOnly', '0').set('limit', ThemeConfig.itemsPerPage.toString())

    pageId
      ? params = params.set('pageId', pageId)
      : params = params.delete('pageId')
    pageNumber
      ? params = params.set('pagenr', pageNumber)
      : params = params.set('pagenr', '1')

    if (noLimit) {
      params = params.delete('limit')
    }

    if (filterItems && filterItems.length) {
      filterItems.forEach(filterItem => {
        if (params.has('filter')) {
          params = params.append('filter', filterItem.code)
        } else {
          params = params.set('filter', filterItem.code)
        }
      })
    }

    if (additionalParams) {
      const parsedParams = additionalParams.split('=')
      params = params.set(parsedParams[0], parsedParams[1])
    }

    if (onlyInStock)
      params = params.set('inStockOnly', '1')

    if (searchTerm) {
      const encodedSearchParam = encodeURIComponent(searchTerm)
      url = `${url}?search=${encodedSearchParam}`
    }

    if (type) {
      params = params.set('type', type)
    }

    if (sortOrder) {
      params = params.set('sort', sortOrder)
    }

    return this.http.get<RequestWrap<Product[]>>(
      url,
      { observe: 'response', params }
    ).pipe(handleEmpty())
  }

  public findProduct(id: string, customerId: string): Observable<Product> {
    let url = `/products/${id}`

    return this.http.get<Product>(
      environment.baseApiUrl + url, {
        params: {
          customerId
        }
      }
    )
  }

  public getFavoritesIds(customerId: string): Observable<FavoriteProduct[]> {
    const params = new HttpParams().set('customerId', customerId)

    return this.http.get<RequestWrap<FavoriteProduct[]>>(
      `${environment.baseApiUrl}${favoritesUrl}`,
      { observe: 'response', params }
    ).pipe(handleEmpty()).pipe(map(res => res.results))
  }

  public addFavorite(customerId: string, productCode: string): Observable<FavoriteProduct> {
    return this.http.post<FavoriteProduct>(
      `${environment.baseApiUrl}${favoritesUrl}`,
      {
        customerId,
        productCode
      }
    )
  }

  public removeFavorite(favoriteId): Observable<any> {

    return this.http.delete<any>(
      `${environment.baseApiUrl}${favoritesUrl}/${favoriteId}`,
      { observe: 'response' }
    )
  }

  public getProductOrderHistory(customerId, productCode): Observable<RequestWrap<ProductOrderHistory[]>> {
    let params = new HttpParams().set('customerId', customerId).set('productCode', productCode)
    return this.http.get<RequestWrap<ProductOrderHistory[]>>(
      `${environment.baseApiUrl}${productHistoryUrl}`,
      {
        observe: 'response',
        params
      }
    )
      .pipe(handleEmpty())
  }
}
